import { render, staticRenderFns } from "./Bulletin.vue?vue&type=template&id=62887243&scoped=true&"
import script from "./Bulletin.vue?vue&type=script&lang=js&"
export * from "./Bulletin.vue?vue&type=script&lang=js&"
import style0 from "./Bulletin.vue?vue&type=style&index=0&id=62887243&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62887243",
  null
  
)

export default component.exports